import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import { RedImmobile, RedValutazione } from '../../../types/red'
import { METODI_VALUTAZIONE_LABEL, EUR } from '../../../constants/red'
import { redApi } from '../../../services/api'

const TabValutazioni: React.FC<{ immobile: RedImmobile; onUpdate: () => void }> = ({ immobile, onUpdate }) => {
  const [valutazioni, setValutazioni] = useState<RedValutazione[]>([])
  const [loading, setLoading] = useState(true)
  const [showForm, setShowForm] = useState(false)
  const [form, setForm] = useState({ metodo: 'dcf', valore_stimato: '', noi_stimato_annuo: '', cap_rate_applicato: '', tasso_sconto: '', orizzonte_investimento_anni: '', data_valutazione: '', note: '' })

  const load = () => {
    redApi.valutazioni.listByImmobile(immobile.id).then(res => {
      setValutazioni(res.data)
      setLoading(false)
    })
  }

  useEffect(load, [immobile.id])

  const handleCreate = async () => {
    if (!form.data_valutazione) { toast.error('Data valutazione obbligatoria'); return }
    try {
      await redApi.valutazioni.create({
        immobile_id: immobile.id,
        metodo: form.metodo,
        valore_stimato: form.valore_stimato ? parseFloat(form.valore_stimato) : null,
        noi_stimato_annuo: form.noi_stimato_annuo ? parseFloat(form.noi_stimato_annuo) : null,
        cap_rate_applicato: form.cap_rate_applicato ? parseFloat(form.cap_rate_applicato) : null,
        tasso_sconto: form.tasso_sconto ? parseFloat(form.tasso_sconto) : null,
        orizzonte_investimento_anni: form.orizzonte_investimento_anni ? parseInt(form.orizzonte_investimento_anni) : null,
        data_valutazione: form.data_valutazione,
        note: form.note || null,
      })
      toast.success('Valutazione aggiunta')
      setForm({ metodo: 'dcf', valore_stimato: '', noi_stimato_annuo: '', cap_rate_applicato: '', tasso_sconto: '', orizzonte_investimento_anni: '', data_valutazione: '', note: '' })
      setShowForm(false)
      load()
      onUpdate()
    } catch { toast.error('Errore creazione') }
  }

  if (loading) return <div className="text-gray-400">Caricamento...</div>

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-gray-800">Valutazioni Immobiliari</h2>
        <button onClick={() => setShowForm(v => !v)} className="btn-primary text-sm">+ Aggiungi</button>
      </div>

      {showForm && (
        <div className="card p-4 mb-4 grid grid-cols-3 gap-3">
          <div><label className="label">Metodo</label>
            <select className="select" value={form.metodo} onChange={e => setForm({...form, metodo: e.target.value})}>
              {Object.entries(METODI_VALUTAZIONE_LABEL).map(([k,v]) => <option key={k} value={k}>{v}</option>)}
            </select>
          </div>
          <div><label className="label">Valore stimato (€)</label><input type="number" className="input" value={form.valore_stimato} onChange={e => setForm({...form, valore_stimato: e.target.value})} /></div>
          <div><label className="label">NOI annuo (€)</label><input type="number" className="input" value={form.noi_stimato_annuo} onChange={e => setForm({...form, noi_stimato_annuo: e.target.value})} /></div>
          <div><label className="label">Cap Rate %</label><input type="number" step="0.01" className="input" value={form.cap_rate_applicato} onChange={e => setForm({...form, cap_rate_applicato: e.target.value})} /></div>
          <div><label className="label">Tasso sconto %</label><input type="number" step="0.01" className="input" value={form.tasso_sconto} onChange={e => setForm({...form, tasso_sconto: e.target.value})} /></div>
          <div><label className="label">Orizzonte (anni)</label><input type="number" className="input" value={form.orizzonte_investimento_anni} onChange={e => setForm({...form, orizzonte_investimento_anni: e.target.value})} /></div>
          <div><label className="label">Data valutazione</label><input type="date" className="input" value={form.data_valutazione} onChange={e => setForm({...form, data_valutazione: e.target.value})} /></div>
          <div className="col-span-2"><label className="label">Note</label><input className="input" value={form.note} onChange={e => setForm({...form, note: e.target.value})} /></div>
          <div className="col-span-3"><button onClick={handleCreate} className="btn-primary text-sm">Salva</button></div>
        </div>
      )}

      <div className="space-y-2">
        {valutazioni.map(v => (
          <div key={v.id} className="flex items-center justify-between bg-white border border-gray-200 rounded-lg p-3">
            <div>
              <div className="text-sm font-medium text-gray-800">{METODI_VALUTAZIONE_LABEL[v.metodo] || v.metodo}</div>
              <div className="text-xs text-gray-400">
                Data: {new Date(v.data_valutazione).toLocaleDateString('it-IT')}
                {v.valore_stimato != null && ` · Valore: ${EUR.format(v.valore_stimato)}`}
                {v.cap_rate_applicato != null && ` · Cap Rate: ${v.cap_rate_applicato}%`}
                {v.noi_stimato_annuo != null && ` · NOI: ${EUR.format(v.noi_stimato_annuo)}`}
              </div>
            </div>
            <button onClick={async () => { if (!confirm('Eliminare?')) return; await redApi.valutazioni.delete(v.id); toast.success('Eliminata'); load(); onUpdate() }} className="text-xs text-red-500 hover:text-red-700">🗑</button>
          </div>
        ))}
        {valutazioni.length === 0 && <div className="text-center py-10 text-gray-400">Nessuna valutazione registrata.</div>}
      </div>
    </div>
  )
}

export default TabValutazioni
